import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH EPG ITEM TO EDIT ********************
export const fetchEpgItem = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_EPG_ITEM_LOADING,
			payload: true
		});

		const { data } = await services.get(`/products/programs/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_EPG_ITEM_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_EPG_ITEM_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
